import {Component} from '@angular/core';
import {WizardPageBaseComponent} from '@utils-lib';
import {UmsatzsteuerAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'common-ui-umsatzsteuer-angaben',
  templateUrl: './umsatzsteuer-angaben.component.html'
})
export class UmsatzsteuerAngabenComponent extends WizardPageBaseComponent<UmsatzsteuerAngaben> {

  static nutzdatenPath = 'umsatzsteuerAngaben';
  static route = 'umsatzsteuer-angaben';

  constructor(protected readonly activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
    return new Map<string, unknown | Array<unknown>>([]);
  }
}
